import React, { useEffect, useState } from 'react';
import { AppShell } from '@/components/nav/AppShell';
import { issuesApi } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { TriangleAlert } from 'lucide-react';
import { toast } from 'sonner';
import { fmtDate } from '@/lib/format';
import { EmptyState } from '@/components/empty/EmptyState';
import { ListSkeleton } from '@/components/common/ListSkeleton';
import { Link } from 'react-router-dom';

export default function IssuesPage() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const load = async () => {
    try {
      setItems(await issuesApi.list());
    } catch {
      // surfaced by the api response interceptor
    } finally {
      setLoaded(true);
    }
  };
  useEffect(() => { load(); }, []);

  const change = async (id, status) => {
    await issuesApi.changeStatus(id, status);
    toast.success(`Status → ${status}`);
    load();
  };

  return (
    <AppShell title="Issue Reports">
      <div className="mb-6">
        <h1 className="font-display text-2xl md:text-3xl font-semibold">Issue Reports</h1>
        <p className="text-sm text-muted-foreground">Damage / missing items reported by your team.</p>
      </div>
      {!loaded ? (
        <ListSkeleton />
      ) : items.length === 0 ? (
        <EmptyState icon={TriangleAlert} title="No issues reported" description="Cleaners can report issues from any job page." />
      ) : (
        <Card><CardContent className="p-0"><div className="divide-y">
          {items.map(it => (
            <div key={it.id} className="flex flex-col md:flex-row md:items-center justify-between gap-3 px-4 py-3 transition-colors hover:bg-muted/40">
              <div className="min-w-0 flex-1">
                <div className="font-medium text-sm">{it.title}</div>
                <div className="text-xs text-muted-foreground">Job <Link to={`/jobs/${it.job_id}`} className="hover:underline">{it.job_id.slice(0, 6)}</Link> • {fmtDate(it.created_at)}</div>
                {it.description && <div className="text-xs mt-1">{it.description}</div>}
              </div>
              <div className="flex items-center gap-2 flex-wrap">
                <Badge variant="outline">{it.severity}</Badge>
                <Badge variant="outline">{it.status}</Badge>
                {it.status === 'reported' && <Button size="sm" variant="outline" onClick={() => change(it.id, 'assigned')}>Assign</Button>}
                {it.status !== 'resolved' && <Button size="sm" onClick={() => change(it.id, 'resolved')}>Resolve</Button>}
              </div>
            </div>
          ))}
        </div></CardContent></Card>
      )}
    </AppShell>
  );
}
